import { store } from '@betacrew/jars-flux'
import { PAGE_STATE } from '../../constants/constants';
export const componentKey = "PLANS";

const { actions } = store.reducerManager.add({
	key: componentKey,
	addedReducers: {
		setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },
		setPurchasePlanDetails: (state, action) => {
            state.purchasePlanDetails = action.payload;
        }, 
		setUserPlanReminderData: (state, action) =>{
            state.userPlanReminderData = action.payload;
        }
	},
	initialReducerState: {
		loadingState: { state: PAGE_STATE.LOADING, message: "" },
		purchasePlanDetails: [],
		userPlanReminderData: {},
	}
});
export const { setLoadingState, setPurchasePlanDetails, setUserPlanReminderData } = actions;